import { Schedule } from "@aura-frontend/omnibus-az-client";
import { DropdownMenuItem, Icons, Tooltip } from "@win-reality/react-ui";

import { canDeleteSchedule } from "@/utils/scheduleUtils";

type DeleteEventMenuItemProps = {
  schedule: Schedule;
  onDelete: () => void;
};

function DeleteEventMenuItem({ schedule, onDelete }: DeleteEventMenuItemProps) {
  const canDelete = canDeleteSchedule(schedule);

  if (canDelete) {
    return (
      <DropdownMenuItem onClick={onDelete} className="light:text-error">
        Delete Event
      </DropdownMenuItem>
    );
  }

  return (
    <Tooltip variant="dark" content="External events cannot be deleted.">
      <span className="cursor-not-allowed">
        <DropdownMenuItem disabled className="light:text-error ">
          <Icons.InfoIconOutline className="size-4" />
          Delete Event
        </DropdownMenuItem>
      </span>
    </Tooltip>
  );
}

export { DeleteEventMenuItem };
